import API, { DATA_API } from 'helpers/api'
import { processReceiversSettingsData } from './processContactSettingsData'
import notificationSettingsStore from 'config/store/NotificationSettingsStore'

export default async () => {
  const accountExists = notificationSettingsStore.accounts.some(
    (account: { id: string }) =>
      account.id === notificationSettingsStore.selectedAccount
  )
  if (!notificationSettingsStore.selectedAccount || !accountExists) {
    return new Map()
  }

  const accountIds = notificationSettingsStore.selectedAccount ? [notificationSettingsStore.selectedAccount] : []

  const params = {
    accountIds
  }

  function fetchReceiversSetting () {
    return API.get({
      api: DATA_API,
      url: '/settings/account',
      params: params
    })
  }

  function fetchAllContacts() { 
    return API.get({
      api: DATA_API,
      url: '/accounts/contacts',
      params: params
    })
  }

  const [receiversSettings, allContacts] = await Promise.all([fetchReceiversSetting(), fetchAllContacts()])

  return processReceiversSettingsData(receiversSettings.notification, allContacts.records)
}